import {TweenLite} from "gsap";

class Trailer {
    constructor(windowSizes) {
        this.windowSizes = windowSizes

        this.duration = 1.5
        this.button = document.querySelector('.c-magnetic-btn')
        this.container = document.querySelector('.section-trailers__trailer__iframe')
        this.closeButton = document.querySelector('.section-trailers__trailer__iframe__close')
    }

    init() {
        this
            .button
            .addEventListener('click', () => {
                this.onClickButton()
            })
        /*this
            .closeButton
            .addEventListener('click', () => {
                this.onCloseButton()
            })*/
    }

    autoplayVideo() {
        const iframe = document
            .createRange()
            .createContextualFragment('<iframe src="' + this.container.dataset.src + '" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscr' +
                    'een allowfullscreen></iframe>')
        this
            .container
            .appendChild(iframe)
    }

    onClickButton() {

        this.container.style.display = 'block'

        this
            .button
            .remove()

        TweenLite.fromTo(this.container, this.duration, {
            opacity: 0
        }, {
            opacity: 1,
            ease: Quint.easeInOut
        })

        this.autoplayVideo()
    }

    onCloseButton() {

        TweenLite.to(this.container, this.duration, {
            opacity: 0,
            ease: Quint.easeInOut,
            onComplete: () => {

                this.container.style.display = 'none'
            }
        })
    }

    resize(windowSizes) {
        this.windowSizes = windowSizes
    }
}

export default Trailer


// WEBPACK FOOTER //
// ./src/js/components/Trailer.js